import { useEffect, useState, useContext, useRef } from "react";
import { useHistory } from "react-router";
import { Link } from 'react-router-dom';

import { LayoutContext } from "../layout/";

import { cookie } from 'shared-kernel/helpers';
import { getEndpoint, formatNumber } from "../helper";

import Loader from "../loader";

function useAutoHide(delay = 1000) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!visible) return;

        const timer = setTimeout(() => setVisible(false), delay);
        return () => clearTimeout(timer);
    }, [visible, delay]);

    return [visible, () => setVisible(true)];
}

const Radio = ({ checked }) => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px">
        {checked ? (
            <path fill='#158c7f' d="M480-280q83 0 141.5-58.5T680-480q0-83-58.5-141.5T480-680q-83 0-141.5 58.5T280-480q0 83 58.5 141.5T480-280Zm0 200q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Z" />
        ) : (
            <path className='f-cc' d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Z" />
        )}
    </svg>
)

export default function Checkout({ }) {
    const history = useHistory();

    const [addresses, setAddresses] = useState([]);
    const [bankGateways, setBankGateways] = useState([]);
    const [postalMethods, setPostalMethods] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedAddressId, setSelectedAddressId] = useState(0);
    const [selectedPostalMethodId, setSelectedPostalMethodId] = useState(0);
    const [isFreeMethodActive, setIsFreeMethodActive] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const cartIdRef = useRef(cookie.get('cid'));

    const [showToast, triggerToast] = useAutoHide(2000);

    const { mobile, setPageTitle } = useContext(LayoutContext);

    const handleDeleteAddress = id => {
        fetch(getEndpoint(`/api/android/useraddress/delete?id=${id}`))
            .then(() => {
                fetch(getEndpoint(`/api/android/useraddress/getall?username=${mobile}`))
                    .then(res => res.json())
                    .then(data => setAddresses(data.data));
            });
    }

    const AddressBox = ({ id, fullAddress, userMobile, firstName, lastName }) => {
        return (
            <div>
                <input
                    type="radio"
                    name="address"
                    value={id}
                    checked={selectedAddressId === id}
                    onChange={() => setSelectedAddressId(id)}
                    id={`rb_${id}`}
                    className='d-n'
                />
                <label htmlFor={`rb_${id}`} className='c-p'>
                    <div className='d-f ai-c' style={{ color: '#555' }}>
                        <Radio checked={selectedAddressId === id} />
                        <div className='mr-2'>{fullAddress}</div>
                    </div>
                </label>
                <div className='d-f ai-fs mt-3 mr-4'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" style={{ transform: 'scaleX(-1)' }}>
                        <path fill="#555555" d="M23.188 12.844l-2.938-2.938q-0.563-0.563-0.313-1.375 0.75-2.25 0.75-4.75 0-0.563 0.375-0.938t0.938-0.375h4.688q0.563 0 0.938 0.375t0.375 0.938q0 9.375-6.656 16.031t-16.031 6.656q-0.563 0-0.938-0.375t-0.375-0.938v-4.688q0-0.563 0.375-0.938t0.938-0.375q2.5 0 4.75-0.75 0.75-0.313 1.375 0.313l2.938 2.938q5.813-3 8.813-8.813z"></path>
                    </svg>
                    <div className='mr-2' style={{ color: '#555' }}>{userMobile}</div>
                </div>
                <div className='d-f ai-fs mt-2 mr-4'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32">
                        <path fill="#777777" d="M16 17.156q3.375 0 7.031 1.469t3.656 3.844v2.688h-21.375v-2.688q0-2.375 3.656-3.844t7.031-1.469zM16 14.469q-2.188 0-3.75-1.563t-1.563-3.75 1.563-3.781 3.75-1.594 3.75 1.594 1.563 3.781-1.563 3.75-3.75 1.563z"></path>
                    </svg>
                    <div className='mr-2' style={{ color: '#777' }}>{firstName}&nbsp;{lastName}</div>
                </div>
                <div className='d-f pr-4 mt-2'>
                    <div className='d-f ai-c'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32">
                            <path fill='#2668b4' d="M20.563 20.594l-1.875 1.875-8-8 8-8 1.875 1.875-6.125 6.125z"></path>
                        </svg>
                        <Link className='mr-3' style={{ fontSize: '.9em', color: '#2668b4' }} to={`/address/${id}`}>ویرایش آدرس</Link>
                    </div>
                    <div className='d-f ai-c mr-a'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32">
                            <path fill='#ff0000' d="M25.313 7.031l-7.438 7.438 7.438 7.438-1.875 1.875-7.438-7.438-7.438 7.438-1.875-1.875 7.438-7.438-7.438-7.438 1.875-1.875 7.438 7.438 7.438-7.438z"></path>
                        </svg>
                        <button type='button' className='mr-1' style={{ fontSize: '.9em', color: '#ff0000' }} onClick={e => handleDeleteAddress(id)}>حذف آدرس</button>
                    </div>
                </div>
                <div className='my-4' style={{ height: '1px', backgroundColor: '#f1f1f1' }} />
            </div>
        );
    }

    const PostalMethodBox = ({ id, title }) => {
        let className = 'postal-method ';

        if (isFreeMethodActive) {
            if (id === 1) {
                className += 'c-p';
            } else {
                className += 'inactive pe-n';
            }
        }
        else {
            if (id === 1) {
                className += 'inactive pe-n';
            } else {
                className += 'c-p';
            }
        }

        return (
            <div className='mb-2'>
                <input
                    type="radio"
                    name="address"
                    value={id}
                    checked={selectedPostalMethodId === id}
                    onChange={() => setSelectedPostalMethodId(id)}
                    id={`rb_${id}`}
                    className='d-n'
                />
                <label htmlFor={`rb_${id}`} className={className}>
                    <div className='d-f ai-c'>
                        <Radio checked={selectedPostalMethodId === id} />
                        <div className='mr-2'>{title}</div>
                    </div>
                </label>
            </div>
        );
    }

    useEffect(() => {
        setPageTitle('انتخاب آدرس');

        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                setLoading(true);
                let response = await fetch(getEndpoint(`/api/android/useraddress/getall?username=${mobile}`), { signal });
                let json = await response.json();
                setAddresses(json.data);

                response = await fetch(getEndpoint(`/api/android/BankGateway/getall`), { signal });
                json = await response.json();
                setBankGateways(json.data);

                response = await fetch(getEndpoint(`/api/android/PostalMethod/getall`), { signal });
                json = await response.json();
                const _postalMethods = json.data;
                setPostalMethods(_postalMethods);

                response = await fetch(getEndpoint(`/api/android/product/getcart?cartid=${cartIdRef.current}`));
                json = await response.json();

                if (json.data.length === 0) {
                    sessionStorage.setItem('orderSuccess', '1');

                    history.push('/');
                }

                let payablePrice = 0;

                for (const item of json.data) {
                    payablePrice += (item.price * item.quantity);
                }

                if (payablePrice >= _postalMethods[0].freeMethodThreshold) {
                    setIsFreeMethodActive(true);
                    setSelectedPostalMethodId(1);
                }

            } catch (err) {
                if (err.name !== "AbortError") setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

        return () => controller.abort();
    }, []);

    const handleSubmit = () => {
        if (selectedAddressId < 1) {
            setToastMessage('انتخاب آدرس الزامی است.');
            triggerToast();
            return;
        }
        if (selectedPostalMethodId < 1) {
            setToastMessage('انتخاب روش ارسال الزامی است.');
            triggerToast();
            return;
        }

        setLoading(true);

        fetch(getEndpoint("/api/android/order/submit"), {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                username: mobile,
                cartId: cartIdRef.current,
                addressId: selectedAddressId,
                postalMethodId: selectedPostalMethodId
            })
        })
            .then(res => res.json())
            .then(data => {
                sessionStorage.setItem('orderSuccess', '1');
                history.push('/');
            });
    }

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <div className='p-4' style={{ backgroundColor: '#f5f5f5', paddingBottom: '6.2rem' }}>
            <div className='bc-w p-4 br-4 mb-4'>
                {addresses?.map(x => (
                    <AddressBox
                        key={x.id}
                        id={x.id}
                        fullAddress={x.fullAddress}
                        userMobile={x.mobile}
                        firstName={x.firstName}
                        lastName={x.lastName}
                    />
                ))}
                <Link className='d-f ai-c' to='/address'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32">
                        <path d="M21.313 11.781v-2.625h-4v-4h-2.625v4h-4v2.625h4v4h2.625v-4h4zM16 1.156q3.875 0 6.594 2.719t2.719 6.594q0 1.938-0.969 4.438t-2.344 4.688-2.719 4.094-2.281 3.031l-1 1.063q-0.375-0.438-1-1.156t-2.25-2.875-2.844-4.188-2.219-4.594-1-4.5q0-3.875 2.719-6.594t6.594-2.719z"></path>
                    </svg>
                    <div className='mr-4'>اضافه کردن آدرس جدید</div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" className='mr-a'>
                        <path d="M20.563 20.594l-1.875 1.875-8-8 8-8 1.875 1.875-6.125 6.125z"></path>
                    </svg>
                </Link>
                <div className='mt-4' style={{ height: '1px', backgroundColor: '#f1f1f1' }} />
            </div>
            <div className='bc-w p-4 br-4 mb-4'>
                <div className='d-f ai-c mb-2' style={{ color: '#777777' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32">
                        <path className='f-cc' d="M24 23.156q0.875 0 1.438-0.594t0.563-1.406-0.563-1.406-1.438-0.594-1.438 0.594-0.563 1.406 0.563 1.406 1.438 0.594zM26 11.156h-3.313v3.313h5.938zM8 23.156q0.875 0 1.438-0.594t0.563-1.406-0.563-1.406-1.438-0.594-1.438 0.594-0.563 1.406 0.563 1.406 1.438 0.594zM26.688 9.156l4 5.313v6.688h-2.688q0 1.625-1.188 2.813t-2.813 1.188-2.813-1.188-1.188-2.813h-8q0 1.625-1.188 2.813t-2.813 1.188-2.813-1.188-1.188-2.813h-2.688v-14.688q0-1.063 0.813-1.875t1.875-0.813h18.688v5.375h4z"></path>
                    </svg>
                    <div className='mr-2'>انتخاب شیوه ارسال</div>
                </div>
                {postalMethods?.map(x => (
                    <PostalMethodBox
                        key={x.id}
                        id={x.id}
                        title={x.title}
                    />
                ))}

                <div className='ta-c'>
                    <div className='d-ib ta-s' style={{ fontSize: '.9em', color: '#aaaaaa', lineHeight: '1.3' }}>
                        حداقل مبلغ سفارش برای ارسال رایگان {formatNumber(postalMethods[0].freeMethodThreshold)} ریال <br />می باشد.
                    </div>
                </div>
            </div>
            <div className='bc-w p-4 br-4'>
                <div className='d-f ai-c mb-2' style={{ color: '#777777' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32">
                        <path className='f-cc' d="M26.688 9.156v-2.688h-21.375v2.688h21.375zM26.688 22.469v-8h-21.375v8h21.375zM26.688 3.781q1.125 0 1.875 0.781t0.75 1.906v16q0 1.125-0.75 1.906t-1.875 0.781h-21.375q-1.125 0-1.875-0.781t-0.75-1.906v-16q0-1.125 0.75-1.906t1.875-0.781h21.375z"></path>
                    </svg>
                    <div className='mr-2'>درگاه پرداخت</div>
                </div>
                <div className='d-f jc-c'>
                    <div className='ta-c'>
                        <img src={getEndpoint('/pwa/img/saman_bank_logo.png')} className='bank-logo' />
                        <div className='mt-2' style={{ color: '#757575' }}>سامان</div>
                    </div>
                </div>
            </div>
            <button type='button' className='d-f ai-c jc-c c-w fs-3 _bc-b p-f b-0 l-0 r-0' style={{ height: '5rem' }} onClick={handleSubmit}>ثبت سفارش</button>

            {showToast && (
                <div className='toast p-f b-4 l-0 r-0 d-f jc-c'>
                    <div className='d-if px-5 py-3 br-999' style={{ backgroundColor: '#f0f0f0' }}>
                        {toastMessage}
                    </div>
                </div>
            )}
        </div>
    );
}